export const ErrorPagesRouter = [
  {
    path: '*',
    redirect: { name: 'PageNotFound' }
  },
  {
    path: '/page-not-found',
    name: 'PageNotFound',
    component: () => import('../../views/ErrorPages/PageNotFound')
  }
];